// extracted by mini-css-extract-plugin
module.exports = {"svg":"flower-module--svg--UTNZN","path":"flower-module--path--3wfBR","dash":"flower-module--dash--1dJJ1"};